import axios from 'api';
import { getCurrentApiUrl } from 'app/helpers';

require('dotenv').config();

export const GET_USERS = '[CONSOLE] GET USERS';
export const GET_SWITCHED_USER = '[CONSOLE] GET SWITCHED USERS';
export const SET_USERS_SEARCH_TEXT = '[CONSOLE] SET USERS SEARCH TEXT';

export function getUsers(brand_id) {
  let requestAnimators;
  let requestCoordinators;
  let requestFranchises;

  if (brand_id) {
    requestAnimators = axios.get(
      `${getCurrentApiUrl()}/users/animators?brand_id=${brand_id}`,
      {}
    );
    requestFranchises = axios.get(
      `${getCurrentApiUrl()}/users/franchisees?brand_id=${brand_id}`,
      {}
    );
    requestCoordinators = axios.get(
      `${getCurrentApiUrl()}/users/coordinators?brand_id=${brand_id}`,
      {}
    );
  } else {
    requestAnimators = axios.get(`${getCurrentApiUrl()}/users/animators`, {});
    requestFranchises = axios.get(
      `${getCurrentApiUrl()}/users/franchisees`,
      {}
    );
    requestCoordinators = axios.get(
      `${getCurrentApiUrl()}/users/coordinators`,
      {}
    );
  }

  return dispatch =>
    requestAnimators
      .then(a => {
        requestFranchises
          .then(f => {
            requestCoordinators
              .then(c => {
                dispatch({
                  type: GET_USERS,
                  payload: {
                    supervisors: a.data.concat(c.data),
                    animators: a.data,
                    franchises: f.data,
                    coordinators: c.data
                  }
                });
              })
              .catch(err => err);
          })
          .catch(err => err);
      })
      .catch(err => err);
}

export function setUsersSearchText(event) {
  return {
    type: SET_USERS_SEARCH_TEXT,
    searchText: event.target.value
  };
}
